<template>
  <div/>
</template>

<script>
  import * as cookieUtils from '@Foundation/utilities/cookies';
  export default {
    name: 'newsletter-signup-header',
    props: {
      newsletterId: { type: String, default: 'newsletter',required: true },
      registrationSubSourceCookie: { type: String, default: 'mdc-registration-sub-source',required: true },
      registrationSubSourceValue: { type: String, default: 'header',required: true }
    },
    data() {
      return {
        isNewsletterId: this.newsletterId !== '' ? true : false,
        isRegistrationSubSourceCookie: this.registrationSubSourceCookie !== '' ? true : false,
        isCookieFired: false,
      };
    },
    mounted() {
      const newsletterNavItem = document.getElementById(this.newsletterId);
      if (newsletterNavItem) {
        /* istanbul ignore next */
        newsletterNavItem.addEventListener('click',()=> {
          this.setNewsletterHeaderCookie();
        });
      }
    },
    methods: {
      setNewsletterHeaderCookie() {
        cookieUtils.setCookie(this.registrationSubSourceCookie, this.registrationSubSourceValue, '1');
      }
    }
  };
</script>
